module.exports = __webpack_public_path__ + "static/media/crocodile(21).a0d98849.PNG";